import { Colors } from '../../style/colors'
import { Typography } from '../../style/typography'
import React from 'react'

export const WidgetTitle: React.FC<{title: string; className?: string}> = ({ title, className }) => (
  <h2 className={className} css={[Typography.label.label4_600, Colors.Color.eerieBlack500, { whiteSpace: 'nowrap' }]}>{title}</h2>
)
